const Jwt = {

  decode(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  }

};

export default Jwt;



// WEBPACK FOOTER //
// ./src/services/Jwt.js